export class Tabs {
  constructor() {
    const sidebars = document.querySelectorAll('._tabs__sidebar');
    const contents = document.querySelectorAll('._tabs__content');

    sidebars.forEach((s, sid) => {
      const wrappers = s.querySelectorAll('.tm-button-wrapper');
      const buttons = s.querySelectorAll('.tm-button');
      const texts = contents[sid].querySelectorAll('.wpb_text_column');

      buttons.forEach((b, bid) => {
        b.addEventListener('click', e => {
          e.preventDefault();

          wrappers.forEach((w, wid) => {
            if (wid === bid) {
              w.classList.add('active');
            }
            else {
              w.classList.remove('active');
            }
          });

          texts.forEach((t, tid) => {
            if (tid === bid) {
              t.classList.add('active');
            }
            else {
              t.classList.remove('active');
            }
          });
        });
      });
    });
  }
}

export default new Tabs;
